import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-ng-select',
  template: `    
    <label for="">{{field.props?.label}} <span *ngIf="field.props?.required">*</span></label>
    <ng-select [items]="field.props?.options"
      [multiple]="field.props?.multiple"
      [bindValue]="field.props?.bindValue"
      [bindLabel]="field.props?.bindLabel" 
      [clearable]="!field.props?.required"
      [formControl]="formControl">
    </ng-select>
  `
})
export class FormlyFieldNgSelectComponent extends FieldType<FieldTypeConfig> {
  get labelProp(): string { return this.field.props?.labelProp || 'label'; }
  get valueProp(): string { return this.field.props?.valueProp || 'value'; }
  get groupProp(): string { return this.field.props?.groupProp || 'group'; }
}
